// utils/saveNudge.js — Anamoria SPA
// v0.1 — 3.1-N save-nudge decline counter (D-3.9; O-3 stop rule)
//
// Per-user, on-device memory of "Save without a name" declines. After
// NUDGE_STOP_AFTER cumulative declines the nudge never shows again
// (O-3, closed 2026-07-19: "the product takes no for an answer").
//
// Design notes (draft v0.2 §E, dispositioned as recommended 2026-07-21):
//   - localStorage is the appropriate store (OWASP HTML5 CS: preference data,
//     no auth assumed); persistent by O-3's own wording ("remembered on the
//     device"), so sessionStorage is ruled out.
//   - FAIL-OPEN (F-N2): unavailable/throwing storage reads as 0 and writes are
//     swallowed — the nudge may reappear, a save is never blocked.
//   - UNTRUSTED ON READ (F-N1): Number(x) || 0 — a tampered value only changes
//     whether a prompt shows, never an authorization outcome.
//   - Key is per-user via Auth0 sub (first per-user localStorage key in the
//     repo; a counter is not a token — ADR-003 untouched).

export const NUDGE_STOP_AFTER = 2;

const storageKey = (sub) => `anamoria.saveNudgeDeclines.${sub}`;

export const readNudgeDeclines = (sub) => {
  try { return Number(localStorage.getItem(storageKey(sub))) || 0; }
  catch { return 0; }
};

export const bumpNudgeDeclines = (sub) => {
  try { localStorage.setItem(storageKey(sub), String(readNudgeDeclines(sub) + 1)); }
  catch { /* fail-open */ }
};

// The one question the page asks (keeps the gate logic testable in isolation).
export const shouldNudge = (sub) => readNudgeDeclines(sub) < NUDGE_STOP_AFTER;
